module.exports = __webpack_public_path__ + "img/Res_Tramdepot_kl.9bbc4f86.jpg";